import { Users, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function TeamPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Team</h1>
          <p className="text-sm text-foreground-muted">Invite and manage team members</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Invite Member
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Users className="h-10 w-10" />}
          title="No team members yet"
          description="Invite team members to collaborate on your 3D printing projects."
          actionLabel="Invite Member"
          onAction={() => {
            // TODO: Open invite member modal
          }}
        />
      </div>

      {/* Team Roles Info */}
      <div className="mt-6 max-w-2xl space-y-4">
        <h3 className="text-sm font-medium text-foreground">Team Roles</h3>
        <div className="rounded border border-border bg-background-subtle p-4 space-y-3">
          <div>
            <h4 className="text-sm font-medium text-foreground">Owner</h4>
            <p className="text-xs text-foreground-muted">Full access to all workspace settings and billing</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-foreground">Admin</h4>
            <p className="text-xs text-foreground-muted">Manage team members, printers, and inventory</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-foreground">Member</h4>
            <p className="text-xs text-foreground-muted">View and create prints, manage own items</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-foreground">Viewer</h4>
            <p className="text-xs text-foreground-muted">Read-only access to workspace data</p>
          </div>
        </div>
      </div>
    </div>
  );
}
